<template>
  <div class="card">
    <div class="card-header d-flex align-items-center">
      <h5 class="mb-0">
        <slot />
      </h5>

      <div class="ml-auto" />

      <a-button
        class="ml-2"
        :disabled="loading"
        @click="list()"
      >
        <fa-icon
          :spin="loading"
          :icon="['fas','sync-alt']"
        />
      </a-button>
    </div>
    <div class="card-header d-block d-md-flex align-items-end bb-1">
      <div class="mb-3 mb-md-0">
        <small class="bold">Fechas:</small>
        <br>
        <a-range-picker
          v-model="dfilters.date"
          :disabled="loading"
          :placeholder="['Desde', 'Hasta']"
          :ranges="ranges"
          class="w-100 w-md-auto"
        />
      </div>
      <div class="ml-auto" />
      <div class="ml-md-3 mb-3 mb-md-0">
        <small class="bold">Turno:</small>
        <br>
        <a-select
          v-model="dfilters.turns"
          :disabled="loading"
          allow-clear
          mode="multiple"
          placeholder="Turnos"
          :style="{'min-width': '100px'}"
          class="w-100 w-md-auto"
        >
          <a-select-option
            v-for="(item,index) in filters.turns"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <a-button
        class="ml-md-3 mb-3 mb-md-0 d-inline-block"
        type="danger"
        :disabled="loading || !filtered"
        @click="clear()"
      >
        <fa-icon
          :sping="loading"
          :icon="['fas','eraser']"
          class="mr-2"
        /> Borrar
      </a-button>

      <div class="ml-2 d-inline-block">
        <a-button
          type="primary"
          :disabled="loading"
          @click="setFilters"
        >
          <fa-icon
            :icon="['fas', 'filter']"
            class="mr-2"
          /> Filtrar
        </a-button>
      </div>
    </div>
    <div class="card-body">
      <!-- <div v-if="loading">
				<g-caption
					:icon="['fas','chart-pie']"
					:size="['18px','42px']"
					:delay="0"
					animated="flip"
					infinite
				>
					<b class="text-uppercase">Cargando</b>
				</g-caption>
			</div> -->
      <div
        v-if="e404"
        class="text-center"
      >
        <img
          src="@/system/assets/images/public/empty.png"
          class="mb-2"
        >

        <h4 class="text-gray-6">
          No se encontraron resultados
        </h4>
      </div>
      <vue-c3
        v-else
        :handler="handler"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import VueC3 from 'vue-c3';
import 'c3/c3.min.css';

export default {
	components: {
		VueC3
	},
	props: {
		filters: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			handler: new Vue(),
			dfilters: {
				date: [this.$moment().subtract(31, 'days'), this.$moment()],
				turns: []
			},
			ranges: {
				Hoy: [this.$moment(), this.$moment()],
				Ayer: [this.$moment().startOf(1, 'days'), this.$moment().subtract(1, 'days')],
				'Este mes': [this.$moment().startOf('month'), this.$moment()],
				'Esta semana': [this.$moment().startOf('week'), this.$moment()]
			},
			options: {
				data: {
					columns: [],
					type: 'gauge'
				},
				gauge: {
					label: {
						format(value) {
							return `${value.toFixed(1)}`;
						},
						show: true
					},
					units: ' %',
					min: 0,
					max: 150
				},
				color: {
					pattern: ['#FF0000', '#FFFF00', '#92D050', '#00B050'],
					threshold: {
						unit: 'value',
						max: 150,
						values: [100, 110, 130, 150]
					}
				},
				size: {
					height: 180
				}
			},
			loading: false,
			loaded: false,
			e404: false
		};
	},
	computed: {
		filtered() {
			if (this.turns) return true;

			return false;
		},
		date: {
			get() {
				return this.$vault.get('pmStats_date');
			},
			set(val) {
				return this.$vault.set('pmStats_date', _.cloneDeep(val));
			}
		},
		turns: {
			get() {
				return this.$vault.get('pmStats_turns');
			},
			set(val) {
				return this.$vault.set('pmStats_turns', _.cloneDeep(val));
			}
		},
		data: {
			get() {
				return this.$vault.get('pmStats_data');
			},
			set(val) {
				return this.$vault.set('pmStats_data', _.cloneDeep(val));
			}
		}
	},
	created() {
		if (this.date) this.dfilters.date = this.date;
		if (this.turns) this.dfilters.turns = this.turns;
	},
	mounted() {
		if (this.data) {
			this.options.data.columns = this.data;
			this.handler.$emit('init', _.cloneDeep(this.options));
			this.loaded = true;
		} else {
			this.list();
		}
	},
	methods: {
		async list(refresh = false) {
			this.loading = true;
			this.e404 = false;

			if (!this.date) {
				this.date = [this.$moment().subtract(31, 'days'), this.$moment()];
				this.dfilters.date = this.date;
			}

			const params = {
				date: JSON.stringify([this.$moment(this.date[0]).format('YYYY-MM-DD'), this.$moment(this.date[1]).format('YYYY-MM-DD')]),
				turns: JSON.stringify(this.turns),
				refresh: refresh ? 1 : 0
			};

			const result = await this.$lambda.get('stats/pm', { params });

			this.loading = false;

			if (result.ok) {
				this.data = result.data.data;

				if (this.loaded) {
					const unloadFilters = this.filters.turns.filter((t) => {
						const find = result.data.data.findIndex((c) => c[0] === t);
						if (find < 0) return true;
						return false;
					});

					this.handler.$emit('dispatch', (chart) => chart.load({
						columns: this.data,
						unload: unloadFilters
					}));
				} else {
					this.options.data.columns = this.data;
					this.handler.$emit('init', this.options);
				}

				this.loaded = true;
			} else {
				this.e404 = true;
			}
		},
		setFilters() {
			this.date = this.dfilters.date;
			this.turns = this.dfilters.turns;

			this.list();
		},
		clear() {
			this.date = [this.$moment().subtract(31, 'days'), this.$moment()];
			this.turns = [];

			this.dfilters.date = this.date;
			this.dfilters.turns = this.turns;
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
